// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2K4u2","title":"ClientInsurance_title__d2lJc","itemText":"ClientInsurance_itemText__3klZA"};